import { Switch } from '@mui/material';
import { styled } from '@mui/material/styles';

const TRACK_WIDTH = 58;
const TRACK_HEIGHT = 22;
const THUMB_SIZE = 18;
const THUMB_INSET = (TRACK_HEIGHT - THUMB_SIZE) / 2;

export const LabeledSwitch = styled(Switch)(({ theme }) => ({
  width: TRACK_WIDTH + 16,
  height: TRACK_HEIGHT + 16,
  padding: 8,
  '& .MuiSwitch-switchBase': {
    padding: 8 + THUMB_INSET,
    '&.Mui-checked': {
      transform: `translateX(${TRACK_WIDTH - THUMB_SIZE - THUMB_INSET * 2}px)`,
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.5,
    },
  },
  '& .MuiSwitch-thumb': {
    width: THUMB_SIZE,
    height: THUMB_SIZE,
    boxShadow: 'none',
    color: theme.palette.common.white,
  },
  '& .MuiSwitch-track': {
    position: 'relative',
    borderRadius: TRACK_HEIGHT / 2,
    opacity: 1,
    backgroundColor: theme.palette.grey[400],
    '&::before, &::after': {
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: 10,
      fontWeight: 700,
      lineHeight: 1,
      letterSpacing: 0.4,
      color: theme.palette.common.white,
      transition: theme.transitions.create('opacity'),
    },
    '&::before': {
      content: '"ON"',
      left: 9,
      opacity: 0,
    },
    '&::after': {
      content: '"OFF"',
      right: 7,
    },
  },
  '& .Mui-checked + .MuiSwitch-track': {
    '&::before': { opacity: 1 },
    '&::after': { opacity: 0 },
  },
}));
